import { i18n } from '@/common/locale';

/**
 * 경과 시간(몇 분 전 등) 반환
 */
export const getElapsedTime = (targetTime: number): { time: number; unit: string } => {
  const start = +new Date(targetTime);
  const end = +new Date();
  const diff = (end - start) / 1000;
  const times = [
    { name: i18n.global.t('WORD.ELAPSED_YEAR'), value: 60 * 60 * 24 * 365 },
    { name: i18n.global.t('WORD.ELAPSED_MONTH'), value: 60 * 60 * 24 * 30 },
    { name: i18n.global.t('WORD.ELAPSED_DAY'), value: 60 * 60 * 24 },
    { name: i18n.global.t('WORD.ELAPSED_HOUR'), value: 60 * 60 },
    { name: i18n.global.t('WORD.ELAPSED_MINUTE'), value: 60 },
    { name: i18n.global.t('WORD.ELAPSED_SECOND'), value: 1 },
  ];
  let resultTime;
  let resultUnit;
  for (let i = 0; i < times.length; i++) {
    const time = times[i];
    const betweenTime = Math.floor(diff / time.value);
    if (betweenTime > 0) {
      resultTime = betweenTime;
      resultUnit = time.name;
      break;
    }
  }
  return {
    time: resultTime,
    unit: resultUnit,
  };
};
